import { css, styled } from "styled-components";
import { Button } from "@/src/components/atom/Button";
import TabItem from "@/src/components/molecule/TabItem";
import Typo from "@/src/components/atom/Typo";
import colorSet, { ColorType } from "@/src/styles/color";
import typo from "@/src/styles/typography";
import { ReactComponent as ArrowHookSvg } from "@/src/assets/icons/icon-arrow-hook-red.svg";
import { ReactComponent as DeleteSvg } from "@/src/assets/icons/icon-cancle-red.svg";
import { ReactComponent as RedoSvg } from "@/src/assets/icons/icon-redo-blue.svg";

export const OrderDateText = styled.span`
  color: var(--Gray-Gray-6, #6e777c);

  /* Body/Body5 - 19M */
  font-family: Pretendard;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 136.842% */
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 72px;
`;

export const BottomButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    gap: 8px;
  }
`;

export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  figure {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const ArrowHookIcon = styled(ArrowHookSvg)<{
  color?: ColorType;
  disabled?: boolean;
}>`
  width: 16px;
  height: 16px;

  path {
    ${({ color }) =>
      color &&
      css`
        fill: ${colorSet[color]};
      `}

    ${({ disabled }) =>
      disabled &&
      css`
        fill: ${colorSet.red6};
      `}
  }
`;

export const DeleteIcon = styled(DeleteSvg)<{
  color?: ColorType;
  disabled?: boolean;
}>`
  width: 16px;
  height: 16px;

  path {
    ${({ color }) =>
      color &&
      css`
        fill: ${colorSet[color]};
      `}

    ${({ disabled }) =>
      disabled &&
      css`
        fill: ${colorSet.red6};
      `}
  }
`;

export const RedoIcon = styled(RedoSvg)<{
  color?: ColorType;
  disabled?: boolean;
}>`
  width: 16px;
  height: 16px;

  path {
    ${({ color }) =>
      color &&
      css`
        fill: ${colorSet[color]};
      `}

    ${({ disabled }) =>
      disabled &&
      css`
        fill: ${colorSet.gray8};
      `}
  }
`;

export const NoDataContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ClientName = styled(Typo).attrs({
  as: "span",
})`
  display: block;
  padding-top: 8px;
  color: ${colorSet.gray1};
  ${typo.b5m}
`;

export const Tabs = styled.div`
  display: flex;
  border-radius: 8px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
`;

export const StyledTabItem = styled(TabItem)<{
  isSelect?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 8px 16px;
  border: none;
  border-right: 1px solid ${colorSet.gray9};
  cursor: pointer;
  background: ${({ isSelect }) =>
    isSelect ? colorSet.indigo : colorSet.gray11};
  border: 1px solid ${colorSet.gray9};

  &:last-child {
    border-right: none;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
`;

export const BottomContainer = styled.div<{ $bottomStartPoint?: number }>`
  position: fixed;
  bottom: 0;
  left: ${({ $bottomStartPoint }) => `${$bottomStartPoint}px`};
  width: calc(100% - 256px);
  right: 0;
  padding: 16px 24px;
  z-index: 10;
  background-color: ${colorSet.white};
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.1);
`;
